export default {
  authStatus: false,
  token: null,
  isSingingSuccesOutlook: false,
  tokenOutlook: '',
  emailOutlook: '',
  accountOutlook: {},
  list: [],
  item: {},
  activationOk: false,
  user: {
    id: '',
    name: '',
    lastName: '',
    email: '',
    roleId: '',
    token: '',
  },
  userSignature: ''
};
